export default `/* Ids Dropdown List Component */
:host {
  display: block;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: var(--ids-input-width-40);
  min-width: calc(var(--ids-input-width-10) - 2px);
  width: var(--ids-input-width-full);
  font-weight: normal;
}

:host(.multi-column) {
  overflow-x: auto;
}

:host(.is-table) {
  display: table;
}

:host(.is-datagrid[field-height=xs]) ::slotted(ids-list-box-option),
:host(.is-datagrid[field-height=xxs]) ::slotted(ids-list-box-option) {
  font-size: var(--ids-font-size-xs);
}

:host([size=xs]),
:host([size=xs]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-10) - 2px);
}

:host([disabled]:not([disabled=false])) {
  cursor: var(--ids-cursor-default);
  opacity: 0.5;
  pointer-events: none;
}

:host([size=sm]),
:host([size=sm]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-20) - 2px);
}

:host([size=md]),
:host([size=md]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-40) - 2px);
  min-height: 32px;
}

:host([size=mm]),
:host([size=mm]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-30) - 2px);
}

:host([size=lg]),
:host([size=lg]) ::slotted(ids-list-box-option) {
  max-width: calc(var(--ids-input-width-50) - 2px);
}

:host([size=full]),
:host([size=full]) ::slotted(ids-list-box-option) {
  max-width: var(--ids-input-width-full);
}

:host([auto-size=true]),
:host([auto-size=true]) ::slotted(ids-list-box-option) {
  max-width: none;
}

:host([input-auto-size=false]) ::slotted(ids-list-box-option) {
  margin-inline-end: 8px;
}

:host([field-height=xxs]) ::slotted(ids-list-box-option) {
  font-size: var(--ids-dropdown-font-size-compact);
  min-height: calc(var(--ids-input-height-10) - 2px);
  line-height: calc(var(--ids-input-height-10) - 2px);
  text-indent: 2px;
}

:host([compact]) ::slotted(ids-list-box-option),
:host([field-height=xs]) ::slotted(ids-list-box-option) {
  font-size: var(--ids-dropdown-font-size-compact);
  min-height: calc(var(--ids-input-height-10) - 2px);
  line-height: calc(var(--ids-input-height-10) - 2px);
  text-indent: 4px;
}

:host([field-height=sm]) ::slotted(ids-list-box-option) {
  min-height: calc(var(--ids-input-height-20) - 2px);
  line-height: calc(var(--ids-input-height-20) - 2px);
  text-indent: 10px;
}

:host([field-height=md]) ::slotted(ids-list-box-option) {
  min-height: calc(var(--ids-input-height-30) - 2px);
  line-height: calc(var(--ids-input-height-30) - 2px);
}

:host([field-height=lg]) ::slotted(ids-list-box-option) {
  min-height: calc(var(--ids-input-height-40) - 2px);
  line-height: calc(var(--ids-input-height-40) - 2px);
}

:host([uppercase]) ::slotted(ids-list-box-option) {
  text-transform: uppercase;
}

:host(.module-nav) {
  max-height: none;
}

:host(ids-list-box) ids-text.first-selected {
  display: block;
  padding: 5px 9px;
}

::slotted(ids-text.first-selected) {
  display: block;
  padding: 5px 9px;
}

::slotted(ids-list-box-option[selected].last-selected) {
  margin-bottom: var(--ids-dropdown-group-padding);
}

::slotted(ids-list-box-option.ellipsis) {
  overflow: hidden;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
